import { Injectable, inject } from '@angular/core';
import type { NativeDateAdapter } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { TranslateService } from 'src/app/core/services/translate/translate.service';

import { useLocale } from './translations.actions';

@Injectable()
export class TranslationEffects {
  private dateAdapter = inject<DateAdapter<NativeDateAdapter>>(DateAdapter);
  private translateService = inject(TranslateService);

  private readonly actions$ = inject<Actions>(Actions);
  useLanguage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(useLocale),
        tap(({ locale }) => {
          this.translateService.use(locale);
          this.dateAdapter.setLocale(locale);
        }),
      ),
    { dispatch: false },
  );
}
